export default function logEvent (name='untitled', details='') {
  try {
    window.clicky.log(`#${name}`, details)
  } catch (e) {
    console.log("no clicky")
  }
}
